<template>
  <div class="welcome">
    <h2>U Lifestyle 商戶申請</h2>
    <div>
      <p>歡迎蒞臨U Lifestyle商戶中心！</p>
      <p>作為緊貼用戶生活的資訊性網絡平台，U Lifestyle掌握豐富的生活資訊，從本地娛樂、飲食、 美容、旅遊等應有盡有，為用戶無限放送各種超強優惠！</p>
      <p>為了讓用戶能免費接觸更多生活貼心推介，U Lifestyle 更增設了《社群》，現時已涵蓋超過40個生活主題，集合民間高質KOL丶Bloggers深度分享打卡熱點丶
        旅遊丶甜品丶食譜、寵物丶人氣熱話等內容，為用戶建構一個貼地交流及記錄生活的強大網絡，打造最個人化的生活地圖。</p>
      <p>立即免費申請成為商戶，透過商戶中心將獨家優惠發佈於U Lifestyle旗下網站及手機App，帳戶批核後將即時同步開通U Lifestyle《社群》商戶帳號
        ，隨時隨地進入U Lifestyle App《社群》專區發佈帖文，火速將最新品牌宣傳內容分享至全香港用戶面前，大大增加店舖人流、網店流量，從而提升銷售及知名度！</p>
    </div>
    <div class="text-center">
      <b-button
        to="/signup"
        variant="primary"
        size="lg"
        @click="onSignUpBtnClicked($event)"
      >
        立即申請
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue';

export default {
  components: {
    BButton,
  },
  methods: {
    onSignUpBtnClicked(e) {
      window.dataLayer.push({
        event: 'btnEventTrigger',
        ga4: {
          channel: 'www',
          event_name: 'mc_apply_now',
          content: {
            id: 'NA',
            type: 'NA',
          },
          function: 'NA',
          text: 'NA',
          section: 'NA',
          service: 'merchant',
          category: 'NA',
          position: 'NA',
          screen: 'NA',
          reward: {
            id: 'NA',
            name: 'NA',
          },
          pageurl: window.location.href,
          clickurl: e.target.href,
          method: 'NA',
        },
      });
    },
  },
  mounted() {
    this.$emit('updated');
  },
};
</script>

<style lang="scss">
.card--auth {
  max-width: 780px !important;
  border-radius: 10px;
}

</style>

<style scoped lang="scss">
.welcome {
  & h2 {
    color: #174169;
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 24px;
    line-height: 31px;
  }

  & p {
    color: #3a4047;
    font-weight: 400;
    font-size: 18px;
  }

  ::v-deep {
    .btn-lg{
    margin-top: 10px;
    font-size: 18px;
    padding: 16px 60px;
}

  }
}
</style>
